/**
 * Часы в подписях — всегда 24-часовые и по-русски («21:05», а не «9:05 PM»).
 *
 * `toLocaleTimeString([])` берёт язык браузера: в англоязычном Chrome
 * телепрограмма показывала «AM/PM» посреди русского интерфейса. Язык и цикл
 * часов задаём явно; форматтеры создаются один раз — их конструктор дорогой,
 * а программа передач зовёт их на каждую строку.
 */
const HM = new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
const HMS = new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });

/** «ЧЧ:ММ» по часам зрителя. */
export function formatClock(at: number | Date): string {
  return HM.format(at);
}

/** «ЧЧ:ММ:СС» по часам зрителя — для журнала и логов. */
export function formatClockSeconds(at: number | Date): string {
  return HMS.format(at);
}
